<script setup>
defineProps({
    label: {
        type: String,
        required: true,
    },
});
</script>

<template>
    <div>
        <span class="mb-1 block text-xs font-bold select-none">{{ label }}</span>
        <div>
            <slot />
        </div>
    </div>
</template>
